import React from 'react'
import WorkLinePlaceForm from './form/WorkLinePlaceForm'
import ErrorMessage from '../UI/messages/ErrorMessage'
import SuccessMessage from '../../helpers/message/SuccessMessage'
import MySpiner from '../UI/spiner/MySpiner'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../helpers/response/ResponseHelper'
import { checkWorkLinePlaceNowAPI } from '../../api/workLinePlace/workLinePlaceAPI'
import WorkLinePlaceResult from './form/result/WorkLinePlaceResult'

const WorkLinePlaceNow = ({ department, workPlacePresence }) => {

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    // console.log('data', data)

    useEffect(() => {
        checkWorkLinePlaceNow()
    }, [])

    const checkWorkLinePlaceNow = () => {
        setError('')
        setLoading(true)
        setData(null)
        checkWorkLinePlaceNowAPI().then(data => {
            setData(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage
            error={error}
        />
        <SuccessMessage
            success={success}
        />

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            data && data.workingHour ?
                <WorkLinePlaceResult 
                    result={data}
                    isWorkNow={true}
                />
            :
                <WorkLinePlaceForm />
        }
        {/* <WorkLinePlaceForm /> */}
    </div>
  )
}

export default WorkLinePlaceNow